const STORAGE_KEY = "jooti.pending-payment";

const storage = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }

  return window.localStorage;
};

const normalizeText = (value) => String(value ?? "").trim();

const normalizeCart = (cart) =>
  (Array.isArray(cart) ? cart : [])
    .map((item) => ({
      product_id: Number(item?._id ?? item?.id ?? 0),
      variant_id: Number(item?.product_variant_id ?? item?.variant_id ?? 0),
      quantity: Number(item?.quantity ?? 0),
      price: Number(item?.price ?? 0),
      sale_price: Number(item?.sale_price ?? item?.campaign_sale_price ?? 0),
      discount: Number(item?.discount ?? item?.discount_percent ?? 0)
    }))
    .sort((left, right) =>
      `${left.product_id}:${left.variant_id}`.localeCompare(
        `${right.product_id}:${right.variant_id}`
      )
    );

const signature = (cart) => JSON.stringify(normalizeCart(cart));

const readPendingPayment = () => {
  try {
    const value = storage()?.getItem(STORAGE_KEY);

    if (!value) {
      return null;
    }

    const parsed = JSON.parse(value);

    if (!parsed?.order_ref || !parsed?.cart_signature) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const rememberPendingPayment = (order, cart) => {
  const orderRef = order?.public_id || order?.id;

  if (!orderRef) {
    return;
  }

  try {
    storage()?.setItem(
      STORAGE_KEY,
      JSON.stringify({
        order_ref: String(orderRef),
        cart_signature: signature(cart),
        saved_at: Date.now()
      })
    );
  } catch {}
};

export const pendingPaymentOrderRef = (cart) => {
  const pending = readPendingPayment();

  if (!pending || pending.cart_signature !== signature(cart)) {
    return null;
  }

  return normalizeText(pending.order_ref) || null;
};

export const clearPendingPayment = (orderRef = null) => {
  try {
    const pending = readPendingPayment();

    if (
      orderRef &&
      pending?.order_ref &&
      String(pending.order_ref) !== String(orderRef)
    ) {
      return;
    }

    storage()?.removeItem(STORAGE_KEY);
  } catch {}
};
